// CentreDetails.jsx
import React, { useState, useEffect } from 'react';
import { 
  MapPin, 
  Star, 
  ArrowLeft, 
  Cpu, 
  Users, 
  Clock, 
  Award,
  Calendar,
  Phone,
  Mail,
  CheckCircle,
  Sparkles,
  Building2,
  Clock as ClockIcon,
  Calendar as CalendarIcon,
  Share2,
  Heart,
  ChevronRight
} from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import './ExploreCentres.css';

const centresData = [
  { 
    id: 1,
    city: "Visakhapatnam", 
    rating: 4.8, 
    machines: 42, 
    experts: 18,
    description: "State-of-the-art prototyping facility with advanced 3D printing and CNC machining capabilities.",
    address: "Plot No. 123, APIIC Industrial Park, Visakhapatnam, AP - 530001",
    phone: "+91 891-234-5678",
    email: "vizag@apicprotohub.in",
    established: "2020",
    facilities: ["3D Printing", "CNC Machining", "PCB Prototyping", "Laser Cutting"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Available",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  },
  { 
    id: 2,
    city: "Vijayawada", 
    rating: 4.7, 
    machines: 36, 
    experts: 14,
    description: "Innovation hub with focus on robotics, automation, and product design prototyping.",
    address: "Survey No. 45, Industrial Area, Vijayawada, AP - 520001",
    phone: "+91 866-345-6789",
    email: "vijayawada@apicprotohub.in",
    established: "2021",
    facilities: ["Robotics", "Automation", "3D Scanning", "Product Design"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Available",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  },
  { 
    id: 3,
    city: "Tirupati", 
    rating: 4.6, 
    machines: 29, 
    experts: 12,
    description: "Advanced manufacturing facility specializing in aerospace components and precision engineering.",
    address: "Plot No. 78, IT Park, Tirupati, AP - 517501",
    phone: "+91 877-456-7890",
    email: "tirupati@apicprotohub.in",
    established: "2021",
    facilities: ["Precision Engineering", "Aerospace", "Quality Testing", "Material Science"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Available",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  },
  { 
    id: 4,
    city: "Kurnool", 
    rating: 4.5, 
    machines: 24, 
    experts: 9,
    description: "Emerging innovation centre with focus on sustainable manufacturing and renewable energy prototyping.",
    address: "Plot No. 234, Industrial Hub, Kurnool, AP - 518001",
    phone: "+91 851-567-8901",
    email: "kurnool@apicprotohub.in",
    established: "2022",
    facilities: ["Sustainable Manufacturing", "Renewable Energy", "IoT", "Smart Sensors"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Available",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  },
  { 
    id: 5,
    city: "Guntur", 
    rating: 4.4, 
    machines: 28, 
    experts: 11,
    description: "Centre of excellence for textile innovation and smart manufacturing solutions.",
    address: "Plot No. 56, Industrial Park, Guntur, AP - 522001",
    phone: "+91 863-678-9012",
    email: "guntur@apicprotohub.in",
    established: "2022",
    facilities: ["Smart Textiles", "Automation", "Process Optimization", "Quality Control"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Available",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  },
  { 
    id: 6,
    city: "Nellore", 
    rating: 4.3, 
    machines: 22, 
    experts: 8,
    description: "Rapid prototyping hub with focus on electronics and PCB development.",
    address: "Plot No. 89, Electronics Park, Nellore, AP - 524001",
    phone: "+91 861-789-0123",
    email: "nellore@apicprotohub.in",
    established: "2023",
    facilities: ["Electronics", "PCB Design", "Hardware Prototyping", "Testing"],
    images: [
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80",
      "https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
    ],
    availability: "Busy",
    hours: "Mon-Sat: 9:00 AM - 6:00 PM"
  }
];

export default function CentreDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [centre, setCentre] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const found = centresData.find(c => c.id === parseInt(id));
    setCentre(found || null);
    setLoading(false);
  }, [id]);

  if (loading) {
    return (
      <div className="centre-details-loading">
        <div className="centre-details-spinner"></div>
        <p>Loading centre details...</p>
      </div>
    );
  }

  if (!centre) {
    return (
      <div className="centre-details-notfound">
        <div className="centre-details-notfound-icon">
          <Building2 size={48} />
        </div>
        <h2>Centre Not Found</h2>
        <p>The centre you're looking for doesn't exist.</p>
        <button onClick={() => navigate('/')} className="centre-details-back-btn">
          <ArrowLeft size={18} />
          Back to Centres
        </button>
      </div>
    );
  }

  return (
    <div className="centre-details">
      <div className="centre-details-container">
        {/* Back Button */}
        <button className="centre-details-back" onClick={() => navigate('/')}>
          <ArrowLeft size={20} />
          Back to Centres
        </button>

        {/* Hero Section */}
        <div className="centre-details-hero">
          <div className="centre-details-hero-image">
            <img src={centre.images[0]} alt={`APIC ${centre.city}`} />
            <div className="centre-details-hero-overlay"></div>
            <div className="centre-details-hero-content">
              <div className="centre-details-hero-badge">
                <Sparkles size={16} />
                <span>APIC Centre</span>
              </div>
              <h1 className="centre-details-hero-title">APIC {centre.city}</h1>
              <div className="centre-details-hero-info">
                <div className="centre-details-hero-info-item">
                  <MapPin size={18} />
                  <span>{centre.address}</span>
                </div>
                <div className="centre-details-hero-info-item">
                  <Star size={18} className="centre-details-hero-star" />
                  <span>{centre.rating} Rating</span>
                </div>
              </div>
              <div className="centre-details-hero-actions">
                <button className="centre-details-hero-btn primary">
                  <Calendar size={18} />
                  Book Visit
                </button>
                <button className="centre-details-hero-btn secondary">
                  <Share2 size={18} />
                  Share
                </button>
                <button className="centre-details-hero-btn secondary">
                  <Heart size={18} />
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Content Grid */}
        <div className="centre-details-grid">
          {/* Main Content */}
          <div className="centre-details-main">
            <div className="centre-details-section">
              <h2 className="centre-details-section-title">About This Centre</h2>
              <p className="centre-details-section-text">{centre.description}</p>
            </div>

            <div className="centre-details-section">
              <h2 className="centre-details-section-title">Facilities & Services</h2>
              <div className="centre-details-facilities">
                {centre.facilities.map((facility, index) => (
                  <div key={index} className="centre-details-facility">
                    <CheckCircle size={18} />
                    <span>{facility}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="centre-details-section">
              <h2 className="centre-details-section-title">Gallery</h2>
              <div className="centre-details-gallery">
                {centre.images.map((img, index) => (
                  <div key={index} className="centre-details-gallery-item">
                    <img src={img} alt={`Gallery ${index + 1}`} />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="centre-details-sidebar">
            <div className="centre-details-sidebar-card">
              <h3 className="centre-details-sidebar-title">Quick Info</h3>
              
              <div className="centre-details-sidebar-item">
                <div className="centre-details-sidebar-icon">
                  <ClockIcon size={18} />
                </div>
                <div>
                  <p className="centre-details-sidebar-label">Working Hours</p>
                  <p className="centre-details-sidebar-value">{centre.hours}</p>
                </div>
              </div>

              <div className="centre-details-sidebar-item">
                <div className="centre-details-sidebar-icon">
                  <CalendarIcon size={18} />
                </div>
                <div>
                  <p className="centre-details-sidebar-label">Established</p>
                  <p className="centre-details-sidebar-value">{centre.established}</p>
                </div>
              </div>

              <div className="centre-details-sidebar-item">
                <div className="centre-details-sidebar-icon">
                  <Cpu size={18} />
                </div>
                <div>
                  <p className="centre-details-sidebar-label">Machines</p>
                  <p className="centre-details-sidebar-value">{centre.machines}+</p>
                </div>
              </div>

              <div className="centre-details-sidebar-item">
                <div className="centre-details-sidebar-icon">
                  <Users size={18} />
                </div>
                <div>
                  <p className="centre-details-sidebar-label">Experts</p>
                  <p className="centre-details-sidebar-value">{centre.experts}+</p>
                </div>
              </div>

              <div className="centre-details-sidebar-divider"></div>

              <div className="centre-details-sidebar-item">
                <div className="centre-details-sidebar-icon">
                  <Phone size={18} />
                </div>
                <div>
                  <p className="centre-details-sidebar-label">Contact</p>
                  <p className="centre-details-sidebar-value">{centre.phone}</p>
                </div>
              </div>

              <div className="centre-details-sidebar-item">
                <div className="centre-details-sidebar-icon">
                  <Mail size={18} />
                </div>
                <div>
                  <p className="centre-details-sidebar-label">Email</p>
                  <p className="centre-details-sidebar-value">{centre.email}</p>
                </div>
              </div>

              <div className="centre-details-sidebar-divider"></div>

              <div className="centre-details-sidebar-availability">
                <div className={`centre-details-sidebar-status ${centre.availability === 'Available' ? 'available' : 'busy'}`}>
                  <span className="centre-details-sidebar-dot"></span>
                  {centre.availability}
                </div>
                <button className="centre-details-sidebar-book-btn">
                  <Calendar size={18} />
                  Book This Centre
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}